import React from "react";
import Title from "../../atoms/title/title";
import { FaCalendarAlt } from "@react-icons/all-files/fa/FaCalendarAlt";
import { FaClock } from "@react-icons/all-files/fa/FaClock";
import { useStaticQuery, graphql, Link } from "gatsby";
import "./recentEditionsHome.scss";
import { dateToRelativeFormat } from "../../../utils/dateToRelativeFormat";
import { calculateReadTime } from "../../../utils/calculateReadTime";

export interface IRecentEditions {
  titulo?: string;
  className?: string;
  limit?: number;
}

const RecentEditionsHome = (props: IRecentEditions) => {
  const data = useStaticQuery(graphql`
    query recentQuery {
      allContentfulSubcategoria(
        filter: { tipoContenido: { eq: "Categoria" } }
      ) {
        nodes {
          titulo
          slug
          tipoContenido
          nombreSubcategoria
          referenciaSubcategorias {
            nroEdicion
            nombreSubcategoria
            tipoContenido
            slug
            createdAt
            referenciaInterna {
              referenciaCabecera {
                imagenHeader {
                  file {
                    url
                  }
                }
                descripcion {
                  content {
                    content {
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  let articulos = data.allContentfulSubcategoria.nodes
    .map((node) => {
      const articles = node.referenciaSubcategorias
        ?.filter(
          (item) => item?.nroEdicion && item?.tipoContenido?.startsWith("Art")
        )
        .map((item) => ({
          ...item,
          slug: node.slug + item.slug,
          categoria: node.nombreSubcategoria,
        }));
      return articles;
    })
    .filter((item) => (item ? item.length >= 1 : false))
    .flat()
    .map((item) => ({
      edicion: item.nroEdicion,
      slug: item.slug,
      categoria: item.categoria,
      titulo: item.nombreSubcategoria,
      descripcion:
        item.referenciaInterna.referenciaCabecera.descripcion?.content[0]
          .content[0].value,
      imagen: item.referenciaInterna.referenciaCabecera.imagenHeader.file.url,
      fecha: dateToRelativeFormat(item.createdAt),
      tiempo: `${calculateReadTime(item.nombreSubcategoria)} minutos`,
    }))
    .sort((art1, art2) =>
      art1.edicion < art2.edicion ? 1 : art1.edicion > art2.edicion ? -1 : 0
    );
    
  // articulos = articulos.filter((art) => art.edicion !== articulos[0].edicion); // filter last edition

  const { titulo } = props;
  
  return (
    <div className="editions">
      {titulo && <Title haveInnerHTML={true} titulo={titulo} />}
      <div className="editions__container">
        {articulos.slice(0, props.limit || 6).map((articulo, key) => (
          <div className="editions__card" key={key}>
            <Link to={"/" + articulo.slug} className="editions__card-link">
              <div
                className="editions__card-img"
                style={{ backgroundImage: `url(${articulo.imagen})` }}
              ></div>
            </Link>
            <Link to={"/" + articulo.slug.split("/", 1)}>
              <p className="editions__card-category">{articulo.categoria}</p>
            </Link>
            <Link to={"/" + articulo.slug}>
              <p className="editions__card-title">{articulo.titulo}</p>
            </Link>
            <div className="editions__card-description">
              {articulo.fecha && (
                <span className="editions__card-date">
                  <FaCalendarAlt /> {articulo.fecha}
                </span>
              )}
              {articulo.tiempo && (
                <span className="editions__card-time">
                  <FaClock /> {articulo.tiempo}
                </span>
              )}
            </div>
            <p className="editions__card-content">{articulo.descripcion}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentEditionsHome;
